// extracted by mini-css-extract-plugin
export default {"inputDiv":"InputFieldNew_inputDiv__lORHe"};